<template>
    <div class="user-card-wrapper">
        <template>
            <div class="row">
                <div class="user-card__scores" v-if="getCoinsData !== null">
                    <div class="user-card__total-scores">
                        <IconStarCircle class="user-card__total-scores-icon" />
                        {{ getCoinsData.ratingPosition || '-' }}
                    </div>
                    <div class="user-card__position">в рейтинге</div>

                    <router-link class="user-card__link" :to="{ name: 'account-ratings' }">
                        <IconRatings />
                    </router-link>
                </div>
                <div class="avatar-block">
                    <div
                        class="user-img"
                        :style="{
                            backgroundImage: `url(${userProfileInfo.avatar})`,
                        }"
                    >
                        <QrCode class="user-card__qr-code" :logo="userProfileInfo.avatar" />
                        <div class="user-card__ref-user-link">
                            <RefUser />
                        </div>
                    </div>
                </div>
                <div v-if="isMobile">
                    <div class="user-id">UserID: {{ userProfileInfo.userId }}</div>
                    <div class="user-name">
                        {{ !!userProfileInfo.surname ? userProfileInfo.surname : '' }}
                        {{ !!userProfileInfo.name ? userProfileInfo.name : '' }}
                        {{ !!userProfileInfo.patronymic ? userProfileInfo.patronymic : '' }}
                    </div>
                </div>
                <div class="user-card__coins-block" v-if="getCoinsData !== null">
                    <div class="user-card__total-coins-text" @click="isShowHistory = true">
                        <IconCoins />
                        <div>{{ spaceInNumber(getCoinsData.totalCoins || 0) }}</div>
                        <IconClock />
                    </div>
                    <!-- Временно: маркет -->
                    <!-- <a href="https://market.rsv.ru" class="user-card__link-market" target="_blank">
                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M15.0004 8V5C15.0004 2.79086 13.2095 1 11.0004 1C8.79123 1 7.00037 2.79086 7.00037 5V8M2.59237 9.35196L1.99237 15.752C1.82178 17.5717 1.73648 18.4815 2.03842 19.1843C2.30367 19.8016 2.76849 20.3121 3.35839 20.6338C4.0299 21 4.94374 21 6.77142 21H15.2293C17.057 21 17.9708 21 18.6423 20.6338C19.2322 20.3121 19.6971 19.8016 19.9623 19.1843C20.2643 18.4815 20.179 17.5717 20.0084 15.752L19.4084 9.35197C19.2643 7.81535 19.1923 7.04704 18.8467 6.46616C18.5424 5.95458 18.0927 5.54511 17.555 5.28984C16.9444 5 16.1727 5 14.6293 5L7.37142 5C5.82806 5 5.05638 5 4.44579 5.28984C3.90803 5.54511 3.45838 5.95458 3.15403 6.46616C2.80846 7.04704 2.73643 7.81534 2.59237 9.35196Z"
                                stroke="#69609f"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                        В маркет
                    </a> -->
                    <a class="user-card__link-how-get-coins" @click="isShowHowGetCoins = true">Как получить баллы?</a>
                </div>
                <div class="col-2_3" :class="{ 'margin-left': !isMobile }">
                    <div class="row user-card-top justify-content">
                        <div class="user-name" v-if="!isMobile">
                            {{ !!userProfileInfo.surname ? userProfileInfo.surname : '' }}
                            {{ !!userProfileInfo.name ? userProfileInfo.name : '' }}
                            {{ !!userProfileInfo.patronymic ? userProfileInfo.patronymic : '' }}
                        </div>
                        <router-link v-if="!isMobile" class="my-data" to="/account/edit">Мои данные </router-link>
                    </div>
                    <div class="row block account-data mb-2">
                        <div
                            class="row account-data-wrap"
                            :class="{
                                'account-data-second-field': index === 1,
                            }"
                            v-for="(item, index) in accountDataForUser"
                            :key="item.name"
                        >
                            <div class="field-name" v-if="item.name !== 'dateOfBirth' && item.name !== 'address'">
                                {{ item.key }}:
                            </div>
                            <div class="field-content" v-html="item.value"></div>
                        </div>
                    </div>
                    <div
                        class="row account-data no-padding-top"
                        v-if="socialNetworks !== null && Object.keys(socialNetworks).length"
                    >
                        <div class="row social">
                            <div class="col-1_3 field-name">Социальные сети:</div>
                            <div class="col-2_3 social-links">
                                <SocialNetworks :netWorks="socialNetworks"></SocialNetworks>
                            </div>
                        </div>
                    </div>

                    <router-link v-if="isMobile" class="full-btn" to="/account/edit"
                        >Перейти к полному профилю
                    </router-link>
                </div>
            </div>
        </template>
        <!--        <Wait2></Wait2>-->
        <Dialog v-model="isShowHistory" overClose class="user-card__dialog">
            <HistoryCoinsDialog />
        </Dialog>
        <Dialog v-model="isShowHowGetCoins" overClose class="user-card__dialog">
            <HowGetCoinsDialog />
        </Dialog>
    </div>
</template>

<script>
import SocialNetworks from './SocialNetworks';
import { mapGetters, mapActions } from 'vuex';
import str_counter from '../../../tools/str_counter';
import IconStarCircle from '@/components/ratings/svg/IconStarCircle.vue';
import IconRatings from '@/components/ratings/svg/IconRatings.vue';
import IconCoins from '@/components/ratings/svg/IconCoins.vue';
import IconClock from '@/components/ratings/svg/IconClock.vue';
import HistoryCoinsDialog from '@/components/ratings/HistoryCoinsDialog.vue';
import HowGetCoinsDialog from '@/components/ratings/HowGetCoinsDialog.vue';
import Dialog from '@/components/UI/Dialog';
import spaceInNumber from '@/tools/spaceInNumber';
import QrCode from '@/components/UI/qr-code/QrCode.vue';

import RefUser from '@/components/UI/ref-user-link/RefUser.vue';
const declensionAge = str_counter('', 'год', 'года', 'лет');
const getters = ['userProfileInfo', 'user', 'isMobile', 'getCoinsData'];
const actions = ['loadProfileData'];
const dataGetters = ['getRegistryValueById'];
const dataActions = ['loadRegistryItems'];
const professionsActions = ['loadProfession'];

export default {
    name: 'UserCard',
    components: {
        SocialNetworks,
        IconStarCircle,
        IconRatings,
        IconCoins,
        IconClock,
        HistoryCoinsDialog,
        HowGetCoinsDialog,
        Dialog,
        QrCode,
        RefUser,
    },
    data: () => ({
        accountDataForUser: {},
        isShowHistory: false,
        isShowHowGetCoins: false,
        dateOfBirth: null,
    }),
    computed: {
        ...mapGetters(getters),
        ...mapGetters('data', dataGetters),
        socialNetworks() {
            return this.user
                ? {
                      vk: this.userProfileInfo.vk,
                      ok: this.userProfileInfo.ok,
                      yt: this.userProfileInfo.yt,
                      telegram: this.userProfileInfo.telegram,
                      tiktok: this.userProfileInfo.tiktok,
                      zen: this.userProfileInfo.zen,
                      rutube: this.userProfileInfo.rutube,
                      yappy: this.userProfileInfo.yappy,
                      tenchat: this.userProfileInfo.tenchat,
                  }
                : null;
        },
    },
    async mounted() {
        await Promise.all([this.loadProfileData(), this.loadRegistryItems({ type: 'industries' })]);

        this.calculateAge();

        this.accountDataForUser = [
            {
                name: 'dateOfBirth',
                key: 'Возраст',
                value: this.userProfileInfo.dateOfBirth ? `${this.dateOfBirth} ${declensionAge(this.dateOfBirth)}` : '',
            },
            {
                name: 'address',
                key: 'Город',
                value: this.userProfileInfo.address ? this.escapeHtml(this.userProfileInfo.address.value) : '',
            },
            {
                name: 'activity',
                key: 'Сфера деятельности',
                value:
                    this.userProfileInfo.activity.length > 0
                        ? '<div>' +
                          this.userProfileInfo.activity
                              .map((activity) => this.getRegistryValueById(activity))
                              .join('</div><div class="pt-8">') +
                          '</div>'
                        : '',
            },

            {
                name: 'about',
                key: 'О себе',
                value: this.userProfileInfo.about ? this.escapeHtml(this.userProfileInfo.about) : '',
            },
        ].filter((value) => value.value);
    },
    methods: {
        ...mapActions(actions),
        ...mapActions('professions', professionsActions),
        ...mapActions('data', dataActions),
        spaceInNumber: spaceInNumber,

        escapeHtml(unsafe) {
            if (typeof unsafe !== 'string') return;
            if (unsafe) {
                return unsafe
                    .replace(/&/g, '&amp;')
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;')
                    .replace(/"/g, '&quot;')
                    .replace(/'/g, '&#039;');
            }
        },
        searchClickHandler() {
            this.$router.push({ name: 'account-user-search' });
        },
        calculateAge() {
            const date = Date.parse(this.userProfileInfo.dateOfBirth);
            const ageDifMs = Date.now() - date;
            const ageDate = new Date(ageDifMs);

            return (this.dateOfBirth = Math.abs(ageDate.getUTCFullYear() - 1970));
        },
    },
};
</script>

<style lang="scss">
@import '~@/styles/rem';
@import '~@/styles/mrem';

.field-content .pt-8 {
    padding-top: rem(8);
}

@import '~@/styles/variables';
@media (max-width: $vm) {
    .field-content .pt-8 {
        padding-top: mrem(8);
    }
}
</style>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/mrem';
/*activate checkbox regExp in finder of phpStorm*/
/*find      {: ([0-9]*)px}*/
/*replace   {: rem($1);}*/

.user-card {
    &__qr-code {
        position: absolute;
        left: mrem(115);
        top: -10px;
    }

    &__ref-user-link {
        position: absolute;
        left: mrem(115);
        top: 45px;
    }

    &__scores {
        display: flex;
        align-items: center;
        gap: mrem(8);

        margin-left: auto;
        margin-bottom: mrem(16);

        @include on-desktop {
            gap: rem(8);
            padding-top: rem(5);
        }
    }

    &__total-scores-icon {
        width: mrem(20);
        height: mrem(20);

        @include on-desktop {
            width: rem(20);
            height: rem(20);
        }
    }

    &__position {
        font-size: mrem(14);
        line-height: mrem(20);
        font-weight: 500;
        color: #2a2626;

        @include on-desktop {
            font-size: rem(16);
            line-height: rem(24);
        }
    }

    &__coins-block {
        padding-bottom: mrem(24);
        border-bottom: mrem(1) solid #d6e0ea;
        margin-bottom: mrem(25);
    }

    &__total-scores {
        display: flex;
        align-items: center;
        gap: mrem(10);

        font-family: 'Montserrat', sans-serif;
        font-weight: 700;
        font-size: mrem(14);

        line-height: mrem(20);
        text-align: center;
        color: #2a2626;

        @include on-desktop {
            gap: rem(10);
            font-size: rem(16);
            line-height: rem(24);
            text-align: right;
            justify-content: flex-end;
        }
    }

    &__link {
        margin-left: auto;
    }

    &__total-coins-text {
        display: flex;
        align-items: center;
        gap: mrem(8);
        font-family: 'Montserrat', sans-serif;
        font-weight: 700;
        font-size: mrem(14);
        line-height: mrem(20);
        color: #2a2626;
        cursor: pointer;
        margin-top: mrem(10);

        div {
            flex-shrink: 0;
        }

        svg {
            width: mrem(24);
            height: mrem(24);
            flex-shrink: 0;
        }

        @include on-desktop {
            gap: rem(8);
            font-size: rem(16);
            line-height: rem(24);
            width: rem(200);

            svg {
                width: rem(24);
                height: rem(24);
                flex-shrink: 0;
            }
        }
    }

    &__link-market {
        border-radius: mrem(10);
        padding: mrem(10) mrem(20);
        width: 100%;
        height: 42px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: mrem(10);
        color: black;
        font-weight: 600;
        font-size: mrem(14);
        line-height: mrem(20);
        margin-top: mrem(20);
        position: relative;
        z-index: 1;

        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(90deg, #e0f7f6 0%, #ede5fb 100%);
            z-index: -1;
            border-radius: mrem(10);
        }

        @include on-desktop {
            border-radius: rem(10);
            padding: rem(9) rem(20);
            height: rem(42);
            font-size: rem(14);
            line-height: rem(20);
            margin-top: rem(20);
            width: rem(160);
            gap: rem(10);

            svg {
                width: rem(22);
            }
        }
    }

    &__link-how-get-coins {
        color: #69609f;
        font-weight: 500;
        font-size: mrem(14);
        line-height: mrem(20);
        text-decoration: underline;
        margin-top: mrem(16);
        display: inline-block;
    }

    &__dialog {
        padding: 0;
        z-index: 999999999999999999;

        ::v-deep div.dialog {
            width: 100vw;
            max-height: 100dvh;
            max-height: 100vh;
            height: 100vh;
            height: 100dvh;
            overflow: auto;
            border-radius: 0;

            @include on-desktop {
                width: rem(680);
                height: rem(780);
                border-radius: rem(10);
                padding-right: rem(10) !important;
            }
        }
    }
}

.full-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: mrem(8) 0;
    width: 100%;
    font-family: 'Proxima Nova', sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: mrem(16);
    line-height: mrem(24);
    color: #4663ab;
    border: mrem(2) solid #4663ab;
    border-radius: mrem(10);
    margin-top: mrem(20);
}

.user-card-top {
    flex-wrap: nowrap;
    margin-bottom: -0.6rem;
}

.user-card-top > * {
    margin-bottom: 0.6rem;
}

.coins-w {
    margin-top: rem(18);
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    .label {
        font-size: rem(16);
        line-height: rem(20);
        color: #98a0a9;
    }

    .coins {
        display: flex;
        flex-direction: row;
        align-items: center;

        .count {
            font-size: rem(14);
            line-height: rem(17);
            color: #2a2626;
        }

        .coin {
            width: rem(24);
            height: rem(24);
            border-radius: 50%;
            margin-left: rem(8);
            background: url(~@/assets/images/account/coin.svg) no-repeat center center;
        }
    }
}

.more {
    width: 100%;
    text-decoration: underline;
    margin-top: rem(10);
    font-size: rem(14);
    line-height: rem(17);
    color: #4663ab;
    cursor: pointer;
}

.setHeight {
    height: 22rem;
}

.row {
    display: flex;
    flex-direction: row;
    width: 100%;
}

.horizontal-center {
    align-items: center;
}

.col-1_3 {
    display: inline-block;
    width: 30%;
}

.col-2_3 {
    display: inline-block;
    width: 70%;
}

.justify-content {
    justify-content: space-between;
}

.account-data {
    > * {
        font-size: 0.65rem;
        line-height: 18px;
    }

    // padding-top: 1rem;

    .row {
        margin-top: rem(24);
    }
}

.account-links {
    padding: rem(24) 0;
    border-top: rem(1) solid #f0f0f0;

    svg {
        margin-right: rem(7);
    }

    span {
        color: #4663ab;
    }

    & > * {
        display: flex;
        margin-right: rem(24);
        font-weight: 600;
        font-size: rem(14);
        line-height: rem(18);
        cursor: pointer;
    }
}

.field-name {
    margin-right: rem(26);
    color: #98a0a9;
    font-size: rem(15);
    font-weight: 600;
    width: 40%;
}

.field-content {
    color: #2a2626;
    font-weight: normal;
    width: 60%;
    word-break: break-word;
}

.block {
    display: block;
}

.align-center {
    display: flex;
    width: 30%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.rating {
    text-align: center;
    width: 100%;
    font-size: 0.7rem;
    font-weight: 500;
    color: #97a4ba;
}

.user-card-wrapper {
    width: 100%;
    padding: 1.4rem;
    background: #ffffff;
    box-shadow: 0 0.3rem 0.5rem rgba(131, 134, 163, 0.12);
    border-radius: 0.25rem;
    min-height: 25rem;

    .user-img {
        width: rem(214);
        height: rem(214);
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
        border-radius: 0.2rem;
        /*border: rem(1) solid black;*/
        display: inline-block;
    }

    .user-id {
        margin-top: 10px;

        color: #98a0a9;
        font-size: rem(18);
        font-weight: 500;

        @include on-mobile {
            font-size: mrem(14);
        }
    }

    .user-name {
        font-size: mrem(16);
        margin-right: 1rem;
        font-weight: 600;
        margin-top: 10px;
    }

    .my-data {
        align-self: flex-start;
        padding-bottom: rem(4);
        border-bottom: rem(1) solid #4663ab;
        font-size: rem(12);
        color: #4663ab;
        white-space: nowrap;
        //text-decoration: underline;
    }

    .margin-left {
        margin-left: rem(24);
    }

    .social {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: row;
        padding-top: rem(21);
        margin-bottom: rem(24);
    }

    .no-padding-top {
        padding-top: 0;
    }
}

@import '~@/styles/variables';
@media (max-width: $vm) {
    .row {
        display: block;

        .pt-8 {
            padding-top: mrem(8);
        }
    }
    .user-card-wrapper {
        padding: mrem(16);

        .my-data {
            font-style: normal;
            font-weight: 500;
            font-size: mrem(14);
            margin-left: 0;
        }
    }

    .avatar-block {
        padding-bottom: mrem(5);
        display: flex;
        flex-direction: row;
        align-items: center;
        position: relative;

        .user-img {
            width: mrem(100);
            height: mrem(100);
            border-radius: mrem(16);
            background-repeat: no-repeat;
            background-size: contain;
        }
    }

    .account-data {
        > * {
            font-family: Montserrat, sans-serif;
            font-style: normal;
            font-weight: normal;
            font-size: mrem(12);
        }

        .row.account-data-second-field {
            margin-top: 0;
        }

        .row {
            margin-top: mrem(16);
            display: flex;
            flex-direction: column;
            line-height: mrem(22);

            .field-name {
                color: #97a4ba;
                font-size: mrem(14);
                line-height: mrem(22);
                font-weight: 600;
                width: 100%;
            }

            .field-content {
                color: #2a2626;
                font-weight: 400;
                line-height: mrem(22);
                font-size: mrem(14);
                width: 100%;

                &:deep(.pt-8) {
                    padding-top: 0;
                }
            }
        }

        .social {
            display: block;
            padding-top: 0;
            padding-bottom: 0;

            .field-name {
                margin-bottom: mrem(10);
            }

            .social-links:deep(.social-links) .social-links-item {
                width: mrem(32);
                height: mrem(32);
            }
        }
    }

    .account-links {
        display: flex;
        padding: 0;
        margin: mrem(32) 0 mrem(20);
        border: 0;

        svg {
            width: mrem(26);
            margin-right: mrem(8);
        }

        span {
            color: #4663ab;
        }

        & > * {
            display: flex;
            margin-right: mrem(24);
            font-weight: 600;
            font-size: mrem(17);
            line-height: mrem(24);
            cursor: pointer;
        }
    }

    .col-1_3 {
        width: 100%;
    }

    .col-2_3 {
        display: block;
        width: 100%;
    }
}
</style>
